import React from 'react';
import { useIntl } from 'react-intl';

import { WebchatColorFormProps } from '.';
import { WebchatColorPicker } from '../component';


const HomeColorInputGroup: React.FC<WebchatColorFormProps> = (props) => {
    const { colors, legend, onChange } = props;

    const intl = useIntl();

    const onChangePrimaryColorStart = (color: string) => {
        onChange({
            ...colors,
            introBackgroundColorStart: color,
            chatPrimaryColor: color,
        } as any);
    };

    const onChangePrimaryColorEnd = (color: string) => {
        onChange({
            ...colors,
            introBackgroundColorEnd: color
        } as any);
    };

    const onChangePrimaryColorText = (color: string) => {
        onChange({
            ...colors,
            introTitleTextColor: color,
            subTitleTextColor: color,
        } as any);
    };

    return (
        <fieldset className="webchat-setting-card-color-container">
            <legend className="sr-only">
                {legend}
            </legend>

            <fieldset className="color-setting-container">
                <legend className="field-label-bold">
                    {intl.formatMessage({ id: "b0022" })}
                </legend>
                <div className="color-setting-body">
                    <div className="color-setting-row">
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09040" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09040" })}
                                            colorKey="introBackgroundColorStart"
                                            colors={colors}
                                            onChange={onChangePrimaryColorStart}
                        />
                        <div className="input-label">
                            {intl.formatMessage({ id: "i09041" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "i09041" })}
                                            colorKey="introBackgroundColorEnd"
                                            colors={colors}
                                            onChange={onChangePrimaryColorEnd}
                        />
                        <div className="input-label">
                            {intl.formatMessage({ id: "b0054" })}
                        </div>
                        <WebchatColorPicker aria-label={intl.formatMessage({ id: "b0054" })}
                                            colorKey="introTitleTextColor"
                                            colors={colors}
                                            onChange={onChangePrimaryColorText}
                        />
                    </div>
                </div>
            </fieldset>
        </fieldset>
    );
};

export default HomeColorInputGroup;
